<template>
  <b-modal
    ref="saveAddressModal"
    :title="$t('shipments.modal.saveAddress')"
    centered
    modal-class="save-address-modal"
  >
    <b-row class="px-3">
      <b-col class="text-center d-flex flex-column">
        <i
          class="fal fa-book-alt main py-2 fa-2x"
          aria-hidden="true"
        />
        <span class="mt-2">{{ $t('La dirección ya está guardada') }}</span>
        <span>
          <strong>{{ $t('¿Deseas sobrescribir o guardar nueva dirección?') }}</strong>
        </span>
      </b-col>
    </b-row>
    <div
      slot="modal-footer"
      class="footer-banner px-2"
      style="width:100%;"
    >
      <div class="row d-flex justify-content-between">
        <b-col>
          <b-button
            block
            size="sm"
            variant="outline-secondary"
            data-dismiss="modal"
            @click="hide"
          >
            {{ $t('global.cancel') }}
          </b-button>
        </b-col>
        <b-col>
          <b-button
            block
            size="sm"
            class="btn__outline"
            @click="addAmendment"
          >
            {{ $t('global.overwrite') }}
          </b-button>
        </b-col>
        <b-col>
          <b-button
            block
            size="sm"
            class="btn--primary"
            @click="addAmendment"
          >
            {{ $t('global.save') }}
          </b-button>
        </b-col>
      </div>
    </div>
  </b-modal>
</template>

<script>
import diagnosisCaseService from '@/modules/diagnosisModule/services/DiagnosisCaseService'

export default {
    name: 'ModalValidatedCase',
    data() {
        return {
            casId: null
        }
    },
    computed: {
        labId() {
            return this.$store.getters.labId
        }
    },
    methods: {
        show(casId) {
            this.$refs.saveAddressModal.show()
            this.casId = casId
        },
        hide() {
            this.$refs.saveAddressModal.hide()
        },
        async addAmendment() {
            this.updateLoading(true)
            const [err] = await this.toCall(diagnosisCaseService.addAmendment(this.labId, this.casId))
            this.updateLoading(false)
            if (err) {
                this.showErrorModalGlobal()
                return
            }
            this.showSuccessModalGlobal(this.$t('diagnosis.amendmentAddedSuccessfully'))
            this.hide()
            this.$emit('amendmentAdded')
        }
    }
}
</script>

<style lang="scss">
    .save-address-modal .modal-dialog {
        max-width: 20%;
    }
    @media (max-width: 1300px) {
        .save-address-modal .modal-dialog {
            max-width: 33%;
        }
    }
    @media only screen and (max-width: 1366px) and (min-width: 1360px) {
        .save-address-modal .modal-dialog {
            max-width: 25%;
        }
    }
</style>
